var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return this.loading
    ? _c(
        "div",
        { staticStyle: { "text-align": "center", "font-size": "xxx-large" } },
        [_vm._v("\n  Loading, please wait...\n")]
      )
    : _c(
        "div",
        {
          staticStyle: {
            "overflow-x": "hidden",
            "overflow-y": "hidden",
            cursor: "grab",
          },
          on: { mousedown: _vm.mouseDownHandler },
        },
        [
          this.$route.params.componentUuids &&
          this.$route.params.componentUuids.length > 0 &&
          this.project.directDependencies &&
          this.project.directDependencies.length > 0 &&
          !this.notFound
            ? _c(
                "span",
                [
                  _c(
                    "c-switch",
                    _vm._b(
                      {
                        staticStyle: {
                          "margin-left": "1.5rem",
                          "margin-right": "0.5rem",
                        },
                        attrs: {
                          id: "showCompleteGraph",
                          color: "primary",
                          label: "",
                        },
                        model: {
                          value: _vm.showCompleteGraph,
                          callback: function ($$v) {
                            _vm.showCompleteGraph = $$v
                          },
                          expression: "showCompleteGraph",
                        },
                      },
                      "c-switch",
                      _vm.labelIcon,
                      false
                    )
                  ),
                  _c("span", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("message.show_complete_graph"))),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "c-switch",
            _vm._b(
              {
                staticStyle: {
                  "margin-left": "1.5rem",
                  "margin-right": "0.5rem",
                },
                attrs: {
                  id: "highlightOutdatedComponents",
                  color: "primary",
                  label: "",
                },
                model: {
                  value: _vm.highlightOutdatedComponents,
                  callback: function ($$v) {
                    _vm.highlightOutdatedComponents = $$v
                  },
                  expression: "highlightOutdatedComponents",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _c("span", { staticClass: "text-muted" }, [
            _vm._v(_vm._s(_vm.$t("message.show_update_information"))),
          ]),
          _c("br"),
          this.notFound
            ? _c("span", [
                _c("span", { staticClass: "text-muted" }, [
                  _vm._v(
                    _vm._s(_vm.$t("message.not_found_in_dependency_graph"))
                  ),
                ]),
                _c("br"),
              ])
            : _vm._e(),
          _c("vue2-org-tree", {
            attrs: {
              data: _vm.data,
              horizontal: true,
              collapsable: _vm.collapsable,
              "label-class-name": _vm.labelClassName,
              "render-content": _vm.renderContent,
              "selected-class-name": "bg-tomato",
              "selected-key": "selectedKey",
            },
            on: { "on-expand": _vm.onExpand, "on-node-click": _vm.onNodeClick },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }